module.exports = __webpack_public_path__ + "img/profitability2.ff51c43d.png";